module.exports = __webpack_public_path__ + "img/kp.373fc27c.svg";